/**
 * Dark Mode Inline Script
 * 
 * Applies the dark mode class to the root element based on saved preference or system setting.
 * 
 * @returns {string} The inline script for dark mode initialization.
 */
function darkMode() {
    return `<script>
        (function () {
            try {
                var p = localStorage.getItem('darkMode');
                var dark = p === null ? window.matchMedia('(prefers-color-scheme: dark)').matches : p === 'true';
                if (dark) document.documentElement.classList.add('dark-mode');
            } catch (e) {}
        })();
    </script>`;
}



/**
 * Init Dark Mode
 * 
 * Toggles dark mode on the root element and stores the preference in localStorage.
 * 
 * @returns {void}
 */
function initDarkMode() {
    const darkModeToggle = document.querySelector('.z-icons button:first-child');
    // The initial class is applied by an inline script in <head> to avoid a flash.
    const root = document.documentElement;
    
    // Toggle dark mode on button click
    if (darkModeToggle) {
        darkModeToggle.addEventListener('click', () => {
            root.classList.toggle('dark-mode');
            const isNowDark = root.classList.contains('dark-mode');
            localStorage.setItem('darkMode', isNowDark);
        });
    }
}

module.exports = { darkMode, initDarkMode };